import { Box, Card, Grid } from '@mui/material';
import { FC } from 'react';
import { Outlet } from 'react-router';
import styles from './Auth.module.css';

export interface AuthConf {
    logoSrc: string;
    logoAlt: string;
    linkToCompany: string;
    title: string;
    subtitle: string;
    backgroundSrc: string;
}

export interface AuthProps {
    conf: AuthConf
}

const Auth: FC<AuthProps> = ({ conf }) => {
    return (
        <div className={styles.Auth} data-testid="Auth" style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${process.env.PUBLIC_URL + conf.backgroundSrc})`,
            backgroundRepeat: 'repeat',
            backgroundSize: '100vw 100vh',
        }}>
            <Box className={styles.content}>
                <Grid container spacing={2}>
                    <Grid item xs={2} md={4}>
                    </Grid>
                    <Grid item xs={8} md={4}>
                        <div>
                            <Card style={{
                                backgroundColor: "#F9F9F9"
                            }}>
                                <a target="_blank" rel="noreferrer" href={conf.linkToCompany}><img className={styles.logo} alt={conf.logoAlt} src={conf.logoSrc}></img></a>
                                {
                                    conf.title &&
                                    <h2>
                                        {conf.title}
                                    </h2>
                                }
                                {
                                    conf.subtitle &&
                                    <div>
                                        {conf.subtitle}
                                    </div>
                                }
                                <Outlet></Outlet>
                            </Card>
                        </div>
                    </Grid>
                    <Grid item xs={2} md={4}>
                    </Grid>
                </Grid>
            </Box>
        </div>
    )
};

export default Auth;
